import React, { useRef, useState } from "react";
import { fileToBase64 } from "../../lib/api";
import { Upload, X } from "lucide-react";

export default function ImageUpload({ value, onChange, label = "Upload photo", testId = "image-upload" }) {
  const inputRef = useRef();
  const [error, setError] = useState("");

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.size > 5 * 1024 * 1024) {
      setError("Image must be under 5MB");
      return;
    }
    setError("");
    const base64 = await fileToBase64(f);
    onChange(base64);
  };

  return (
    <div className="space-y-2">
      <input ref={inputRef} type="file" accept="image/*" onChange={onFile} className="hidden" data-testid={`${testId}-input`} />
      {value ? (
        <div className="relative w-full">
          <img src={value} alt="" className="w-full h-64 object-cover border border-line" />
          <button type="button" onClick={() => onChange(null)} className="absolute top-2 right-2 bg-bg-paper border border-line p-1" data-testid={`${testId}-clear`}>
            <X size={16} />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          className="w-full border-2 border-dashed border-line py-12 flex flex-col items-center justify-center gap-2 text-secondary hover:border-primary hover:text-primary transition-colors"
          data-testid={`${testId}-trigger`}
        >
          <Upload size={20} strokeWidth={1.5} />
          <span className="text-sm">{label}</span>
        </button>
      )}
      {error && <p className="text-xs text-destructive">{error}</p>}
    </div>
  );
}
